import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "GRN Number / Order Date",
  "Project",
  "Vendor / Business Name",
  "PO Number / Po Final Amount",
  // "Po Final Amount",
  "Grn Final Amount",
  "Status",
  "Actions",
];
const GrnTable = ({ GRN = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    id = getId(id);
    navigate(`/view-grn-items/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {GRN?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.grnNumber}>
                <td>{Index}</td>
                <td>{item?.grnNumber || "N/A"}
                  <hr className="m-0 p-0"></hr>
                  <span>{item?.vendorPurchaseOrderDate || "N/A"}</span>
                </td>
              
                <td>
                  {item?.projectClientName ||
                    item?.projectBusinessName ||
                    "N/A"}
                </td>
                <td>
                  {item?.businessName || item?.contactPersonName || "N/A"}
                </td>
                <td>{item?.poNumber || "N/A"}
                  <hr className="m-0 p-0"></hr>
                  <span className="fs-2" style={{ fontWeight: "600" }}>
                      ₹
                      {item?.paymentAmount
                        ? Number(item.paymentAmount).toLocaleString("en-IN")
                        : "0"}
                    </span>
                </td>
                <td> <span className="fs-2" style={{ fontWeight: "600" }}>
                      ₹
                      {item?.finaltotalWithGst
                        ? Number(item.finaltotalWithGst).toLocaleString("en-IN")
                        : "0"}
                    </span></td>
                <td>
                  {item?.approveStatus ? (
                    <span className="text-white badge bg-success">
                      approved
                    </span>
                  ) : (
                    <span className="text-white badge bg-warning">pending</span>
                  )}
                </td>

                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.grnNumber)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default GrnTable;
